import { IRequestService, ILoggerService, IConfigurationService, IDataBackupConfiguration } from '../../services';
import { ComponentDefinition } from '../../models';

interface IAttachApplicationParam {
    workItemId?: number;
    createNewBug?: boolean;
    attachConfig?: IDataBackupConfiguration;
    title?: string;
}

class DebugBadgeController implements angular.IComponentController {
    static $inject = ['$window', 'requestService', 'loggerService', 'configurationService'];

    enabled = false;
    config: IAttachApplicationParam = {};
    isLoading = false;

    constructor(private _$window: angular.IWindowService,
        private _requestService: IRequestService,
        private _loggerService: ILoggerService,
        private _configurationService: IConfigurationService) {
    }

    $onInit() {
        this._configurationService
            .getConfiguration()
            .then(config => this.enabled = !!config.debugBadge);
        this.config.attachConfig = {} as IDataBackupConfiguration;
        this.config.attachConfig.includeModel = true;
    }

    attach() {
        this.isLoading = true;
        this._requestService.postAtV1('debug/attachApplication/', this.config)
            .then(id => {
                this._loggerService.logSuccess(`Sucessfully attached to bug #${id}.`);
                this._$window.open(`https://widetech-com.visualstudio.com/Wide/_workitems/edit/${id}`, '_blank');
            }).catch(reason => {
                this._loggerService.logError('Cannot attach application.');
                this._loggerService.logError(reason);
                console.error(reason);
            }).finally(() => {
                this.isLoading = false;
            });
    }
}

export const wtDebugBadge: ComponentDefinition = {
    componentId: 'wtDebugBadge',
    controller: DebugBadgeController,
    template: require('./debugBadge.component.html'),
    controllerAs: 'vm',
    transclude: true,
    bindings: {
    }
};